import CheckList from '@/pages/CollectionMaterialsIDStudy/CheckList/CheckList';
import Condition from '@/components/Condition';
import CustomEmpty from '@/components/CustomEmpty';

import { Article } from '../article';
import ExistingMaterial from '../ExistingMaterial/ExistingMaterial';
import PokaFiles from '../PokaFiles';
import Presentation from '../Presentation/Presentation';
import { Scorm } from '../scorm';
import { Test } from '../test';
import Tilda from '../tilda';
import { Typeform } from '../typeform';
// import { Video } from '../video';
import { Video } from '../video';

import {
  ARTICLE,
  CHECK_LIST,
  EXISTING_MATERIAL,
  FILE,
  PRESENTATION,
  SCORM,
  TEST,
  TILDA,
  TYPEFORM,
  VIDEO,
} from '@shared/constants/block-type';

import css from '../CollectionMaterialsIDStudy.module.scss';

const Blocks = ({
  currentTest,
  currentUser,
  getStatistic,
  getBlockStatistic,
  topicId,
  updateChaptersIDB,
  removeChaptersFromIDB,
  reviewModalVisible,
  canRestartBlocks,
}) => {
  return (
    <>
      {currentTest.blockType ? (
        <>
          <Condition when={currentTest.blockType.id === TEST}>
            <Test
              key={`test-${currentTest.id}`}
              topicId={topicId}
              currentTest={currentTest}
              currentUser={currentUser}
              getStatistic={getStatistic}
              getBlockStatistic={getBlockStatistic}
              canRestartBlocks={canRestartBlocks}
            />
          </Condition>
          <Condition when={currentTest.blockType.id === SCORM}>
            <Scorm
              key={`scorm-${currentTest.id}`}
              getStatistic={getStatistic}
              block={currentTest}
              topicId={topicId}
              currentUser={currentUser}
              getBlockStatistic={getBlockStatistic}
              canRestartBlocks={canRestartBlocks}
            />
          </Condition>
          <Condition when={currentTest.blockType.id === VIDEO}>
            <Video
              key={`video-${currentTest.id}`}
              getStatistic={getStatistic}
              block={currentTest}
              updateChaptersIDB={updateChaptersIDB}
              removeChaptersFromIDB={removeChaptersFromIDB}
            />
          </Condition>
          <Condition when={currentTest.blockType.id === PRESENTATION}>
            <Presentation
              key={`presentation-${currentTest.id}`}
              getStatistic={getStatistic}
              block={currentTest}
              updateChaptersIDB={updateChaptersIDB}
              removeChaptersFromIDB={removeChaptersFromIDB}
              reviewModalVisible={reviewModalVisible}
            />
          </Condition>

          <Condition when={currentTest.blockType.id === ARTICLE}>
            <Article
              key={`article-${currentTest.id}`}
              getStatistic={getStatistic}
              block={currentTest}
              updateChaptersIDB={updateChaptersIDB}
              removeChaptersFromIDB={removeChaptersFromIDB}
            />
          </Condition>
          <Condition when={currentTest.blockType.id === TYPEFORM}>
            <Typeform key={`typeform-${currentTest.id}`} getStatistic={getStatistic} block={currentTest} />
          </Condition>

          <Condition when={currentTest.blockType.id === TILDA}>
            <Tilda currentUser={currentUser} getStatistic={getStatistic} block={currentTest} />
          </Condition>

          <Condition when={currentTest.blockType.id === EXISTING_MATERIAL}>
            <ExistingMaterial block={currentTest} getStatistic={getStatistic} />
          </Condition>

          <Condition when={currentTest.blockType.id === CHECK_LIST}>
            <CheckList block={currentTest} getStatistic={getStatistic} />
          </Condition>

          <Condition when={currentTest.blockType.id === FILE}>
            <PokaFiles block={currentTest} getStatistic={getStatistic} />
          </Condition>
        </>
      ) : (
        <CustomEmpty className={css['themesEmpty']} />
      )}
    </>
  );
};

export default Blocks;
